import { useRef } from 'react';

import AutomatedCatalogCarouselCardCatalogInfo from '@/components/FeaturedCatalogCarousel/components/AutomatedCatalogCarouselCard/components/CatalogInfo/AutomatedCatalogCarouselCardCatalogInfo';
import AutomatedCatalogCarouselCardItemImages from '@/components/FeaturedCatalogCarousel/components/AutomatedCatalogCarouselCard/components/ItemImages/AutomatedCatalogCarouselCardItemImages';
import { useTrackAndNavigateCatalogCardClick } from '@/components/FeaturedCatalogCarousel/components/AutomatedCatalogCarouselCard/hooks/useTrackAndNavigateCatalogCardClick';
import { useTrackCardVisibility } from '@/components/FeaturedCatalogCarousel/components/AutomatedCatalogCarouselCard/hooks/useTrackCardVisibility';

type Props = {
    catalogId: number;
};

const AutomatedCatalogCarouselCardDesktop = ({ catalogId }: Props) => {
    const cardRef = useRef<HTMLDivElement>(null);

    const trackCardClick = useTrackAndNavigateCatalogCardClick(catalogId);
    useTrackCardVisibility({ cardRef, catalogId });

    return (
        <section
            className="lgMin h-[356px] gap-lg rounded-md bg-gradient-to-b from-background-info-dark to-surface-900 p-md hover:cursor-pointer"
            data-testid="featuredAuctionsCarousel.desktopCard"
            onClick={trackCardClick}
            ref={cardRef}
            role="link"
        >
            <AutomatedCatalogCarouselCardItemImages catalogId={catalogId} />
            <AutomatedCatalogCarouselCardCatalogInfo
                catalogId={catalogId}
                className="mt-md"
            />
        </section>
    );
};

export default AutomatedCatalogCarouselCardDesktop;
